// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import permissionDirective from './directives/permission';
import VueApexCharts from 'vue3-apexcharts';
import './assets/theme.css';
import './assets/responsive.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(permissionDirective); // Registra diretiva v-permission globalmente
// PRD-002 RF-19 — gráficos no Dashboard. The plugin registers the `apexchart`
// component itself (plus apexchart-server/apexchart-hydrate).
app.use(VueApexCharts);

// Inicializa o tema antes de montar a app
import { useThemeStore } from './stores/theme';
const themeStore = useThemeStore(pinia);
themeStore.initTheme();

// PRD-002 estabilização (2026-05-12) — vocabulário do regula-hub
// (labels/descriptions/variants/icons de status, failure_reason, etc).
// Hidrata do localStorage imediatamente (instant render) e dispara fetch
// com If-None-Match em background. Não bloqueia o mount — degradação
// graciosa: se o hub estiver offline, UI usa labels stale ou chave crua.
import { useVocabularyStore } from './stores/vocabulary';
const vocabularyStore = useVocabularyStore(pinia);
vocabularyStore.load(); // fire-and-forget; store gerencia loading state

app.mount('#app');

// PRD-022 INC-1 — registra o service worker da PWA (atrás de flag + HTTPS).
import { registerServiceWorker } from './registerServiceWorker';
registerServiceWorker();
